import React from 'react';
import Typography from '@material-ui/core/Typography';

export default function Forbidden () {
  return(
    <Typography variant="h4" gutterBottom>
      You are mot allowed to view this page.
    </Typography>
  )
}